module.exports = __webpack_public_path__ + "static/media/shape_1.c347ef1f.png";